export enum TOKEN {
    ACCESS = 'accessToken',
    REFRESH = 'refreshToken'
}